function Blank() {
  return (
      <h1>Hello, I'm Blank</h1>
  );
}

export default Blank;
